import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=df9dc4d8&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusTitle: require('/~/src/modules/opus/components/Title.vue').default,ContentfulWidgetList: require('/~/src/modules/contentful/components/widget-list.vue').default,OpusAccordionItem: require('/~/src/modules/opus/components/AccordionItem.vue').default,OpusAccordion: require('/~/src/modules/opus/components/Accordion.vue').default})
